import React from 'react'
import { IconButton, Typography } from '@material-ui/core'
import Dialog from '@material-ui/core/Dialog'
import MuiDialogTitle from '@material-ui/core/DialogTitle'
import MuiDialogContent from '@material-ui/core/DialogContent'
import { makeStyles } from '@material-ui/core/styles'
import CloseIcon from '@material-ui/icons/Close'
import { WarningFillIcon } from 'assets'
import { PrimaryButton } from 'components'

type ConfirmAlertProps = {
  title: string
  open: boolean
  onConfirm(): void
  onReject?: () => void
  onClose(): void
  message?: React.ReactNode
  confirmMessage?: React.ReactNode
  subMessage?: string
  maxWidth?: 'sm' | 'xs' | 'md' | 'lg' | 'xl'
}

const useStyles = makeStyles({
  paper: {
    width: '100%',
  },
})

const ConfirmMessage = (
  <span>
    Click <strong>'Yes'</strong> to confirm or <strong>'No'</strong> to cancel.
  </span>
)

export const ConfirmAlert: React.FC<ConfirmAlertProps> = ({
  open,
  onConfirm,
  onReject,
  onClose,
  title,
  message,
  confirmMessage = ConfirmMessage,
  subMessage,
  maxWidth,
}) => {
  const classes = useStyles()
  return (
    <Dialog
      fullWidth
      maxWidth={maxWidth ?? 'sm'}
      open={open}
      classes={{
        paper: classes.paper,
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      data-testid={'confirm-alert'}
    >
      <MuiDialogTitle className="flex flex-row items-center justify-between" disableTypography>
        <Typography variant="h5">{title}</Typography>
        <IconButton aria-label="close" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </MuiDialogTitle>
      <MuiDialogContent className="w-full">
        <div className="flex flex-row">
          <div className="flex mr-6">
            <WarningFillIcon />
          </div>
          <div className="flex flex-col align-middle pt-3 gap-y-4">
            {message && <div className="text-lg font-light">{message}</div>}
            {subMessage && <div className="text-lg font-light">{subMessage}</div>}
            <div className="text-lg font-light">{confirmMessage}</div>
          </div>
        </div>
      </MuiDialogContent>
      <div className="flex items-center justify-center gap-x-7 pt-4 pb-10">
        <PrimaryButton
          outlined
          buttonText="No"
          onClick={() => {
            if (onReject) {
              onReject()
            } else {
              onClose()
            }
          }}
        />
        <PrimaryButton
          buttonText="Yes"
          onClick={() => {
            onConfirm()
          }}
        />
      </div>
    </Dialog>
  )
}
